import { render, staticRenderFns } from "./AddExamin.vue?vue&type=template&id=101cbb92&scoped=true&"
import script from "./AddExamin.vue?vue&type=script&lang=js&"
export * from "./AddExamin.vue?vue&type=script&lang=js&"
import style0 from "./AddExamin.vue?vue&type=style&index=0&id=101cbb92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101cbb92",
  null
  
)

export default component.exports